import React from 'react';
import { Loader2, CheckCircle } from 'lucide-react';

interface GenerationProgress {
  step: number;
  totalSteps: number;
  message: string;
  isComplete: boolean;
}

interface ProgressIndicatorProps {
  progress: GenerationProgress;
}

export function ProgressIndicator({ progress }: ProgressIndicatorProps) {
  return (
    <div className="px-6 py-4 bg-gradient-to-r from-blue-50 to-purple-50 border-b border-gray-200">
      <div className="flex items-center space-x-3 mb-3">
        <div className="flex items-center space-x-2">
          {progress.isComplete ? (
            <CheckCircle className="w-5 h-5 text-green-600" />
          ) : (
            <Loader2 className="w-5 h-5 animate-spin text-blue-600" />
          )}
          <span className="font-medium text-gray-800">{progress.message}</span>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
        <div
          className={`h-2 rounded-full transition-all duration-500 ${
            progress.isComplete ? 'bg-green-500' : 'bg-blue-500'
          }`}
          style={{ width: `${(progress.step / progress.totalSteps) * 100}%` }}
        />
      </div>

      {/* Step Indicators */}
      <div className="flex justify-between text-xs text-gray-600">
        <span>Step {progress.step} of {progress.totalSteps}</span>
        <span>{Math.round((progress.step / progress.totalSteps) * 100)}% Complete</span>
      </div>
    </div>
  );
}
